import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import { avisosSelector, totalSelector, totalTarefasAvisoSelector } from "../../../store/regulatorioDashboard";
import { fetchAlertas, fetchAlertasByEmpresa, fetchEmpresas, filtrarEmpresas } from "../../../store/empresas";
import NivelCard from "./_NivelCard";

export default function NivelAvisoCard() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatchWithResult();
  const loading = useLoading(fetchEmpresas.typePrefix, fetchAlertasByEmpresa.typePrefix, fetchAlertas.typePrefix);
  const avisos = useSelector(avisosSelector);
  const avisosTarefas = useSelector(totalTarefasAvisoSelector);
  const total = useSelector(totalSelector);

  const handleClick = () => {
    dispatch(filtrarEmpresas({ sucessos: false, avisos: true, erros: false, inativas: false, ativas: true, tabs: [] }));
    history.push("/regulatorio/detalhado");
  };

  return <NivelCard className="background-warning" count={avisos} tarefas={avisosTarefas} loading={loading} title={t("Alertas")} total={total} onClick={handleClick} />;
}
